import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import cn from 'classnames';
import { menuClasses } from './menu';
export var MenuHeader = function MenuHeader(props) {
  var className = props.className,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(menuClasses.HEADER, className);
  return React.createElement("div", _extends({
    className: classNames
  }, htmlProps), React.createElement("div", {
    className: menuClasses.HEADER_TEXT
  }, props.children));
};
MenuHeader.displayName = 'MenuHeader';
MenuHeader.defaultProps = {};